import { render } from "./ErrorComponent.vue?vue&type=template&id=72fde788&scoped=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"

import "./ErrorComponent.vue?vue&type=style&index=0&id=72fde788&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fde788"]])

export default __exports__